import { ButtonIcon, Tooltip, TooltipTrigger } from '@backstage/ui';
import { RiSettings3Line } from '@remixicon/react';

export interface ButtonIconSettingsProps {
  variant: 'tertiary' | 'primary' | 'secondary';
  size: 'small' | 'medium';
  isDisabled?: boolean;
  onClick: () => void;
}

export const ButtonIconSettings = (props: ButtonIconSettingsProps) => {
  const { variant, size, isDisabled, onClick } = props;
  return (
    <TooltipTrigger delay={100}>
      <ButtonIcon
        icon={<RiSettings3Line />}
        variant={variant}
        size={size}
        onClick={onClick}
        isDisabled={isDisabled ?? false}
      />
      <Tooltip placement="bottom">Settings</Tooltip>
    </TooltipTrigger>
  );
};
